import { render, staticRenderFns } from "./_RecycleFinalDisposalFlow.vue?vue&type=template&id=88be8d4e&"
import script from "./_RecycleFinalDisposalFlow.vue?vue&type=script&lang=js&"
export * from "./_RecycleFinalDisposalFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports